import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FiMessageSquare } from 'react-icons/fi';
import PublicNavBar from '../PublicNavBar';
import PublicFooter from '../PublicFooter';
import ChatModal from '../ChatModal';
import LookSwitcher, { lookSwitcherEnabled } from '../LookSwitcher';

const PublicLayout = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    document.body.classList.add('reveal-enabled');
    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = height > 0 ? (scrollTop / height) * 100 : 0;
      const indicatorOffset = height > 0 ? (progress / 100) * 228 : 0;
      document.body.classList.toggle('is-scrolled', scrollTop > 4);
      document.documentElement.style.setProperty(
        '--scroll-progress',
        `${progress}%`
      );
      document.documentElement.style.setProperty(
        '--scroll-indicator-offset',
        `${indicatorOffset}px`
      );
    };

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    return () => {
      document.body.classList.remove('reveal-enabled');
      window.removeEventListener('scroll', updateProgress);
      window.removeEventListener('resize', updateProgress);
    };
  }, []);

  useEffect(() => {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll('.reveal').forEach((element) => {
      element.classList.remove('is-visible');
      revealObserver.observe(element);
    });

    return () => {
      revealObserver.disconnect();
    };
  }, [location.pathname]);

  return (
    <div className="public-shell">
      <div className="scroll-progress" aria-hidden="true" />
      <div className="scroll-indicator" aria-hidden="true">
        <span className="scroll-indicator-label">Scroll</span>
        <span className="scroll-indicator-rail">
          <span className="scroll-indicator-track" />
          <span className="scroll-indicator-dot" />
        </span>
      </div>
      <PublicNavBar />
      <main className="public-content">
        <Outlet />
      </main>
      <section className="contact-strip">
        <div className="contact-strip-inner">
          <div>
            <p className="eyebrow">Contact us</p>
            <h3>Let’s talk about your data needs.</h3>
            <p className="subtitle">
              Tell us about your analytics or engineering goals and we will
              follow up quickly.
            </p>
          </div>
          <form
            className="contact-form"
            action="https://formsubmit.co/trelledex@gmail.com"
            method="POST"
          >
            <input type="hidden" name="_cc" value="trelledex@gmail.com" />
            <input type="hidden" name="_subject" value="Trelledex contact request" />
            <input type="hidden" name="_captcha" value="false" />
            <input
              type="hidden"
              name="_next"
              value={`${window.location.origin}/contact?sent=1`}
            />
            <div className="form-row">
              <input className="input" type="text" name="name" placeholder="Full name" required />
              <input className="input" type="email" name="email" placeholder="Work email" required />
            </div>
            <textarea
              className="input textarea"
              name="message"
              placeholder="How can we help?"
              required
            />
            <button type="submit" className="btn btn-primary">
              Send request
            </button>
          </form>
        </div>
      </section>
      <PublicFooter />
      {chatOpen && <ChatModal onClose={() => setChatOpen(false)} />}
      {lookSwitcherEnabled() && <LookSwitcher />}
      <button
        className="chat-fab-btn"
        type="button"
        onClick={() => setChatOpen(true)}
        aria-label="Chat with us"
      >
        <FiMessageSquare size={22} />
        <span>Chat with us</span>
      </button>
    </div>
  );
};

export default PublicLayout;
